document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.product-accordion details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function() {
      if (this.open) {
        // Close other accordions
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== this && otherAccordion.open) {
            otherAccordion.removeAttribute('open');
          }
        });

        // Delay scrolling slightly to ensure the accordion closing/opening finishes first
        setTimeout(() => {
          // Scroll to the element above the product-accordion container
          const accordionContainer = this.closest('.product-accordion');
          if (accordionContainer) {
            const previousElement = accordionContainer.previousElementSibling;
            if (previousElement) {
              previousElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          }
        }, 100); // 100ms delay to allow accordion transition
      }
    });
  });
});
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.acc-container .accordion details');

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function() {
      if (this.open) {
        // Close other accordions
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== this && otherAccordion.open) {
            otherAccordion.removeAttribute('open');
          }
        });
      }
    });
  });
});
